import ls from 'local-storage';
import { Store } from 'pullstate';

import type { AdminAccess } from '@/api/admin-access';

export const UserStore = new Store({
  authenticated: !!ls('boxpressd_admin_token_id'),
  user: ls('user'), // INFO This is the same as auth.user
  firebaseUser: null,
  access: null as AdminAccess | null,
  loadingAccess: true,
  accessError: null as string | null,
  users: [],
  totalUserCount: 0,
  loadingUsers: true,
});

export const AppStore = new Store({
  showSidebar: false,
});
